// Segurança Pré-Produção, Pacote 4 (P1-4) — política de senha.
//
// Validação client-side é só uma conveniência de UX (feedback imediato,
// sem round-trip) — a fonte de verdade real é sempre o backend
// (_validate_new_password em backend/server.py), que revalida tudo de
// novo em todo request. Por isso este arquivo reproduz só a parte
// ESTRUTURAL da regra (tamanho, letra, número, limite de bytes do
// bcrypt) — a lista de senhas triviais/óbvias NÃO é duplicada aqui; se o
// usuário digitar uma, o backend rejeita e a mensagem de erro real do
// servidor é exibida normalmente (ver formatApiError em lib/api.js).
//
// Ponto ÚNICO usado por todo formulário que define uma senha nova
// (Configurações, Primeiro Acesso, Esqueci minha senha/Redefinir,
// redefinição pelo Admin Master) — nunca uma regex duplicada por tela.
export const PASSWORD_MIN_LENGTH = 10;
export const PASSWORD_MAX_BYTES = 72; // limite real do bcrypt (backend)
export const PASSWORD_HELP_TEXT =
  "A senha deve ter pelo menos 10 caracteres e conter pelo menos uma letra e um número.";
export const PASSWORD_TOO_LONG_TEXT = "A senha é muito longa.";

function utf8ByteLength(value) {
  try {
    return new TextEncoder().encode(value || "").length;
  } catch {
    // Fallback extremamente improvável (TextEncoder é padrão em todo
    // browser suportado) — nunca bloqueia o formulário por causa disso,
    // só deixa de medir bytes com precisão (o backend é quem decide de
    // verdade).
    return (value || "").length;
  }
}

// Letra/número Unicode-aware (mesmo espírito do isalpha()/isdigit() do
// backend — nunca restringe a só ASCII, preservando acentos/outros
// alfabetos já suportados pelo resto do stack).
const HAS_LETTER = /\p{L}/u;
const HAS_DIGIT = /\p{N}/u;

// Devolve uma mensagem de erro (string) quando a senha não atende à
// política, ou null quando ela é válida.
export function passwordPolicyError(pw) {
  const value = pw || "";
  if (utf8ByteLength(value) > PASSWORD_MAX_BYTES) return PASSWORD_TOO_LONG_TEXT;
  if (value.length < PASSWORD_MIN_LENGTH || !HAS_LETTER.test(value) || !HAS_DIGIT.test(value)) {
    return PASSWORD_HELP_TEXT;
  }
  return null;
}
